import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_NODE_FRAGMENT } from '../fragments'

const INGREDIENTS_BY_KEYWORD_QUERY = gql`
  query ingredientsByKeyword($data: IngredientsByKeywordInput!) {
    ingredientsByKeyword(data: $data) {
      results {
        ...IngredientNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default INGREDIENTS_BY_KEYWORD_QUERY
